import "./favicon.svg";
import "./favicon_admin.svg";
import "./index.css";

const ACTION_ITEMS_REFRESH_INTERVAL_MS = 10000;

async function refreshActionItems(actionItems) {
  try {
    const response = await fetch(actionItems.dataset.url, {
      headers: { Accept: "text/html" },
    });
    if (!response.ok) {
      window.setTimeout(
        () => refreshActionItems(actionItems),
        ACTION_ITEMS_REFRESH_INTERVAL_MS,
      );
      return;
    }

    const template = document.createElement("template");
    template.innerHTML = (await response.text()).trim();
    const refreshedActionItems =
      template.content.querySelector("#action-items");

    if (!refreshedActionItems) {
      actionItems.remove();
      return;
    }

    actionItems.replaceWith(refreshedActionItems);
    window.setTimeout(
      () => refreshActionItems(refreshedActionItems),
      ACTION_ITEMS_REFRESH_INTERVAL_MS,
    );
  } catch (_) {
    window.setTimeout(
      () => refreshActionItems(actionItems),
      ACTION_ITEMS_REFRESH_INTERVAL_MS,
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const actionItems = document.querySelector("#action-items");
  if (actionItems) {
    window.setTimeout(
      () => refreshActionItems(actionItems),
      ACTION_ITEMS_REFRESH_INTERVAL_MS,
    );
  }
});

document.addEventListener("click", (event) => {
  const menuButton = event.target.closest("[data-header-menu-toggle]");
  if (menuButton) {
    const menu = document.getElementById(
      menuButton.getAttribute("aria-controls"),
    );
    if (!menu) return;

    const menuIsOpen = menuButton.getAttribute("aria-expanded") === "true";
    menuButton.setAttribute("aria-expanded", String(!menuIsOpen));
    menuButton.setAttribute(
      "aria-label",
      menuIsOpen ? "Open menu" : "Close menu",
    );
    menu.toggleAttribute("data-open", !menuIsOpen);
    document.body.toggleAttribute("data-menu-open", !menuIsOpen);
    menuButton
      .querySelector(".header_menu_open_icon")
      .toggleAttribute("hidden", !menuIsOpen);
    menuButton
      .querySelector(".header_menu_close_icon")
      .toggleAttribute("hidden", menuIsOpen);
    return;
  }

  const button = event.target.closest("[data-password-toggle]");
  if (!button) return;

  const input = button.closest(".password-field")?.querySelector("input");
  if (!input) return;

  const passwordIsVisible = input.type === "text";
  input.type = passwordIsVisible ? "password" : "text";
  button.setAttribute(
    "aria-label",
    passwordIsVisible ? "Show password" : "Hide password",
  );
  button.setAttribute("aria-pressed", String(!passwordIsVisible));
  const hiddenIcon = button.querySelector(".password-hidden-icon");
  const visibleIcon = button.querySelector(".password-visible-icon");

  hiddenIcon.toggleAttribute("hidden", !passwordIsVisible);
  visibleIcon.toggleAttribute("hidden", passwordIsVisible);
});
